import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createHelpSosApi,
  getHelpSosApi,
  updateHelpSosApi,
  deleteHelpSosApi,
  addUsersApi,
  removeUsersApi,
} from "./helpSosApi";

export const getHelpSos = createAsyncThunk(
  "helpSos/get",
  async (params, thunkAPI) => {
    try {
      const res = await getHelpSosApi(params);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const createHelpSos = createAsyncThunk(
  "helpSos/create",
  async (data, thunkAPI) => {
    try {
      const res = await createHelpSosApi(data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateHelpSos = createAsyncThunk(
  "helpSos/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await updateHelpSosApi(id, data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const deleteHelpSos = createAsyncThunk(
  "helpSos/delete",
  async (id, thunkAPI) => {
    try {
      await deleteHelpSosApi(id);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const addUsers = createAsyncThunk(
  "helpSos/addUsers",
  async ({ id, userIds }, thunkAPI) => {
    try {
      await addUsersApi(id, { userIds });
      return { id, userIds };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const removeUsers = createAsyncThunk(
  "helpSos/removeUsers",
  async ({ id, userIds }, thunkAPI) => {
    try {
      await removeUsersApi(id, { userIds });
      return { id, userIds };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const slice = createSlice({
  name: "helpSos",
  initialState: {
    list: [],
    total: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
.addCase(getHelpSos.fulfilled, (state, action) => {
  state.list = action.payload || [];   // ✅ correct
  state.total = action.payload.length || 0;
})
      .addCase(deleteHelpSos.fulfilled, (state, action) => {
        state.helpSos = state.helpSos.filter(i => i.id !== action.payload);
      });
  },
});

export default slice.reducer;